<template>
	<div
		class="goto d-flex align-center px-2"
		:class="[ $vuetify.breakpoint.smAndDown ? 'px-5' : '', color ]"
		:style="{ color: (color == 'white' ? '#1d87fd' : 'white' ) }"
	>
		<a href="#content">
			<v-icon>mdi-chevron-down</v-icon>
		</a>

		<v-spacer></v-spacer>

		<span
			v-for="(breadcrumb, key) in breadcrumbs"
			:key="key"
			class="font-weight-black"
		>
			<span :class="[ breadcrumb.active ? 'accent--text' : '' ]">{{ breadcrumb.name }}</span>

			<span class="mx-2 font-weight-regular" v-if="breadcrumbs.length - 1 != key">/</span>
		</span>
	</div>
</template>

<script>
export default {
	name: "BaseGoto",
	
	props: {
		color: { type: String, default: 'primary' },
		breadcrumbs: { type: Array }
	},

  data: () => ({
    //
	}),
	computed: {
		//
	}
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/variables.scss";

.goto {
  height: 80px;
	
	.v-icon {
		font-size: 50px;
		color: $accent-blue;
	}
}

/* Vuetify xs = extra-small */
@media only screen and (max-width: 600px) {
	.goto {
		height: 40px;

		.v-icon {
			font-size: 25px;
		}
	}
}
</style>